export default __webpack_public_path__ + "static/media/avatar-christmas.c36c4f09.webp";